const home = {
  hero_title: '探索伦理智慧，提升道德认知',
  hero_subtitle: '伦理在线致力为个人与机构提供系统的伦理学知识、案例分析与道德决策培训，帮助您在复杂的现代社会中建立清晰的伦理判断力。',
  hero_cta_explore: '探索课程',
  hero_cta_assessment: '伦理测评',
  stats_articles: '精选文章',
  stats_users: '平台用户',
  stats_experts: '专家团队',
  stats_courses: '精品课程',
  section_categories: '学习分类',
  section_categories_desc: '从理论到实践，全方位覆盖伦理学各个领域',
  section_featured: '精选文章',
  section_featured_desc: '由资深伦理学专家撰写，深度解析伦理议题',
  section_why_us: '为什么选择伦理在线',
  section_why_us_desc: '我们提供专业、系统、实用的伦理学习体验',
  why_card_1_title: '权威专家团队',
  why_card_1_desc: '86位来自顶尖高校的伦理学教授和行业专家，确保内容的学术严谨性和实践指导价值。',
  why_card_2_title: '系统课程体系',
  why_card_2_desc: '从伦理理论到职业应用，120门课程覆盖伦理学全领域，满足不同层次的学习需求。',
  why_card_3_title: '真实案例分析',
  why_card_3_desc: '精选全球经典伦理案例，通过深度剖析培养伦理敏感性和道德推理能力。',
  why_card_4_title: '科学测评工具',
  why_card_4_desc: '基于科尔伯格道德发展理论的测评体系，帮助您了解自身伦理认知水平和发展方向。',
  section_faq: '常见问题',
  section_faq_desc: '关于伦理在线平台的常见问题解答',
  faq_q1: '伦理在线适合哪些人群使用？',
  faq_a1: '伦理在线面向所有对伦理学感兴趣的个人和机构，包括高校学生、教师、企业管理者、公务员、医疗从业者、法律工作者等。无论您是初学者还是已有基础的进阶学习者，都可以在这里找到合适的学习资源。',
  faq_q2: '平台的课程和文章是否免费？',
  faq_a2: '伦理在线提供大量免费的伦理学文章和基础课程。部分高级课程和深度测评服务为付费内容，我们也不定期推出免费开放的学习活动，让更多人能够接触优质的伦理教育资源。',
  faq_q3: '伦理测评的结果如何解读？',
  faq_a3: '我们的伦理测评工具基于科学的道德发展理论设计，测评完成后您将获得一份详细的个人报告，包括各维度的得分分析、与同龄群体的比较以及个性化的提升建议。机构用户还可以获得团队整体伦理素养的评估报告。',
  faq_q4: '如何成为平台的专家作者？',
  faq_a4: '我们欢迎在伦理学及相关领域具有丰富研究和实践经验的专家加入。您可以通过"关于我们"页面的联系方式提交申请，我们的学术委员会将对申请进行审核，通过后即可在平台发布文章和课程内容。',
  section_cta_title: '开启您的伦理学习之旅',
  section_cta_desc: '加入38万学习者，与86位专家一起探索伦理学的智慧世界',
  section_cta_button: '立即开始学习',
};

export default home;